import $ from 'jquery';


const initInput = () => {

	const quantity_input = $('.qty');

	quantity_input.each(function ( ) {
		var counter = $(this);
		let before_link = document.createElement("a");
		let after_link = document.createElement("a");

		before_link.className='amount down';
		before_link.text='-';
		after_link.className='amount up';
		after_link.text='+';

		$(this).before(before_link);
		$(this).after(after_link);

	});
};

initInput();
$( document.body ).on( 'updated_wc_div', function(){
	initInput();
});

$(document).on("click", ".down" , function( counter ) {
	this.parentNode.querySelector('.qty').stepDown();
	$('button[name = "update_cart"]').prop("disabled", false);
});

$(document).on("click", ".up" , function( counter ) {
	this.parentNode.querySelector('.qty').stepUp();
	$('button[name = "update_cart"]').prop("disabled", false);
});

